import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import api from 'services/api';

import Card, { DefaultLoadingBodyComponent } from 'v3/components/Card';
import { Select, Text, Input, Radio, Badge } from 'v3/components';
import { fetchTrackerTypes } from 'utils/fetches';

export default function TrackingData({
  setData,
  data,
  errors,
  saveLoading
}) {

  const [trackerTypes, setTrackerTypes] = useState({});
  const [trackers, setTrackers] = useState();

  useEffect(() => {
    async function fetchTopTrackerTypes(tracker) {
      try {
        const response = await api.get('select/tracker-types', {
          params: {
            tracker: tracker.id,
          },
        });
        setTrackerTypes(response.data);
      } catch (error) {
        setTrackerTypes([]);
      }
    }
    if (data?.tracker) {
      fetchTopTrackerTypes(data?.tracker);
    }
  }, [data?.tracker]);

  useEffect(() => {
    async function fetchTrackers() {
      try {
        const response = await api.get('tracker/App');
        setTrackers(response.data)
      } catch (error) {
        setTrackers([]);
      }
    }
    fetchTrackers();
  }, []);

  return (
    <Card
      LoadingBodyComponent={() => (
        <DefaultLoadingBodyComponent linesCount={1} perLine={1} />
      )}
      header={
        <Text color="#464E5F" type="header">
          Rastreamento
        </Text>
      }
    >
      <Row className="form">
        <Col xl={4} lg={4} md={12} xs={12}>
          <Radio.Group
            label="Rastreado *"
            onChange={({ target }) => setData({ ...data, isTracked: target.value })}
            value={data?.isTracked}
            horizontal
            error={errors?.isTracked}
            disabled={saveLoading}
          >
            <Radio value>
              <Text color="dark" type="label">
                Sim
              </Text>
            </Radio>
            <Radio value={false}>
              <Text color="dark" type="label">
                Não
              </Text>
            </Radio>
          </Radio.Group>
          {errors?.isTracked && (
            <Badge className="mt-1" light variant="error">
              Campo obrigatório
            </Badge>
          )}
        </Col>
        <Col xl={4} lg={4} md={12} xs={12}>
          <Input
            placeholder={
              data?.isTracked ? 'Digite...' : 'Veículo não rastreado'
            }
            disabled={!data?.isTracked || saveLoading}
            label="ID do rastreador"
            value={data?.trackerCode}
            onChange={event =>
              setData({ ...data, trackerCode: event.target.value })
            }
            error={errors?.trackerCode}
          />
        </Col>
        <Col xl={4} lg={4} md={12} xs={12}>
          <Select
            placeholder={
              data?.isTracked ? 'Selecione...' : 'Veículo não rastreado'
            }
            isDisabled={!data?.isTracked || saveLoading}
            label={`Marca rastreador ${data?.isTracked ? '*' : ''}`}
            options={trackers}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.isTracked ? data?.tracker : null}
            onChange={value => setData({ ...data, tracker: value, trackerType: null })}
            error={errors?.tracker}
          />
        </Col>
        <Col xl={4} lg={4} md={12} xs={12} >
          <Select.Async
            onSearch={search => fetchTrackerTypes(search, data?.tracker)}
            value={data?.tracker ? data?.trackerType : null}
            onChange={value => setData({ ...data, trackerType: value })}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            label="Tipo de rastreador"
            placeholder={
              data?.isTracked
                ? data?.tracker
                  ? 'Selecione...'
                  : 'Veículo sem rastreador'
                : 'Veículo não rastreado'
            }
            options={trackerTypes}
            isDisabled={!data?.isTracked || !data?.tracker || saveLoading}
            error={errors?.trackerType}
            NoOptionsComponent={() => (
              <Text>Nenhum tipo cadastrado para o rastreador informado</Text>
            )}
          />
        </Col>
      </Row>
    </Card>
  );
}
